import {
  FETCH_CALENDAR_BEGIN,
  FETCH_CALENDAR_SUCCESS,
  FETCH_CALENDAR_FAILURE,
} from '../actions/calendarActions';

const initialState = {
  item: null,
  loading: false,
  error: null,
};

export default function calendarReducer(state = initialState, action) {
  switch(action.type) {
    case FETCH_CALENDAR_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_CALENDAR_SUCCESS:
      return {
        ...state,
        loading: false,
        item: action.payload.calendar,
      };

    case FETCH_CALENDAR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}